<template lang="pug">
.input-wrapper
  .label {{ label }}
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && validation.$invalid }')
    md-input(v-model='date', @change='onDateChange', placeholder='Ex: 09-16-2019', type='date')
    span.md-error(v-if='formSubmitted && !validation.validDate') Invalid date format, please use MM-DD-YYYY
</template>

<script>
  export default {
    data() {
      return {
        date: this.value
      };
    },
    props: {
      value: {
        type: String
      },
      label: {
        type: String,
        default: 'Date'
      },
      validation: {
        type: Object,
        required: true
      },
      formSubmitted: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onDateChange(date) {
        this.$emit('input', date);
      }
    },
    watch: {
      value(newValue) {
        this.date = newValue;
      }
    },
  };
</script>

<style lang="scss" scoped>
  .label {
    margin-bottom: -15px;
  }
  .input-wrapper {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/DateInput.vue